import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { isMinor } from 'helpers/datetime';
import { SIGN_UP_FORM } from 'modules/Account/constants';
import App from 'modules/App';
export const useIsMinor = ()=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const dateOfBirth = get(formValues, 'values.dateOfBirth');
    return useMemo(()=>dateOfBirth && isMinor(dateOfBirth), [
        dateOfBirth
    ]);
};
